module.exports = __webpack_public_path__ + "img/maintenance_1.aa9587e6.svg";